<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <!-- Status indicator -->
      <!-- Survey information form, status and action buttons -->
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-5">
            My folders and groups
          </h1>
        </div>
      </div>
      <div class="survey-table">

        <div class="table-filter-area">
          <div>
            <b-form-group>
              <b-input type="text" v-model="search" @input="handleSearch" placeholder="Search" />
            </b-form-group>
          </div>
          <div class="d-flex justify-content-end">
            <b-link to="/create/group">
              <b-button variant="primary" class="mr-2 btn-small"><i class="fa fa-regular fa-plus mr-2"></i>New
                group</b-button>
            </b-link>
            <b-button @click.prevent.stop="addNode(parent_node, true)" variant="primary" class="btn-small"><i
                class="fa fa-regular fa-plus mr-2"></i>New folder</b-button>
          </div>
        </div>
        <div class="flex-folders">
          <div class="flex-table">
            <div v-if="loading" class="text-center text-success my-2">
              <b-spinner class="align-middle mr-2" />
              <strong>Loading...</strong>
            </div>
            <div>
              <table class="table mt-4 mb-0">
                <thead>
                  <tr>
                    <th scope="col"><span class="pl-3 ml-2">Folder</span></th>
                    <th scope="col"><span class="d-flex justify-content-end">Actions</span></th>
                  </tr>
                </thead>
              </table>
              <b-form inline @submit.prevent="nullfunction">
                <sl-vue-tree ref="folderTree" v-model="nodes" class="w-100 pt-0 mt-0" :allow-multiselect="allowmultiselect"
                  @drop="nodeDropped" @beforedrop="checkDrop">
                  <template slot="toggle" slot-scope="{ node }">
                    <span v-if="node.data.gdqtype == 2 || node.data.gdqtype == 0">
                      <i v-if="!node.isExpanded && node.children.length > 0" class="fa fa-regular fa-angle-down mr-2" />
                      <i v-if="node.isExpanded && node.children.length > 0" class="fa fa-regular fa-angle-up mr-2" />
                    </span>
                    <!-- span v-if="node.data.gdqtype == 1">
                <span v-if="node.data.group_deleted == 0" class="sl-vue-tree-toggle">A</span>
              </span -->
                  </template>
                  <template slot="title" slot-scope="{ node }" :class="{ 'is-editing': node === editingnode }">
                    <span class="item-icon">
                      <i v-if="node.data.gdqtype == 0 && node.data.folder_id == 0" name="folder"
                        class="fa fa-regular fa-folder" />
                      <i v-if="node.data.gdqtype == 2 && node.data.folder_id == 0" name="folder"
                        class="fa fa-regular fa-folder" />
                      <i v-if="node.data.gdqtype == 0 && node.data.folder_id != 0" name="folder"
                        class="fa fa-regular fa-folder" />
                      <i v-if="node.data.gdqtype == 1" name="folder" class="fa fa-regular fa-users group-clickable"
                        @click.prevent="group_setcurrent(node.data.group_id)" />
                      <fa-icon v-if="node.data.gdqtype == 3" name="trash-alt" />
                      <fa-icon v-if="node.data.gdqtype == 4" name="folder" class="text-primary" />
                    </span>
                    <!-- Type 0 = Folder -->
                    <span v-if="node.data.gdqtype == 0" class="item-text normal-input"
                      :class="(node.data.group_deleted == 1) && muteclass">
                      <span
                        v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id">
                        {{ node.title }}
                      </span>
                      <span
                        v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id">
                        <b-form-input :ref="'f' + node.data.folder_id" v-model="editingnodename" class="item-input"
                          placeholder="Type new name" @keydown.esc="cancelAddNode(node)"
                          @keydown.enter.prevent="saveAddNode" />
                      </span>
                    </span>
                    <!-- Type 1 = Group -->
                    <span v-if="node.data.gdqtype == 1" class="item-text normal-input"
                      :class="(node.data.group_deleted == 1) && muteclass"
                      @click.prevent="group_setcurrent(node.data.group_id)">
                      <span
                        v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id">
                        {{ node.title }}
                      </span>
                      <b-form-input
                        v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id"
                        :ref="'g' + node.data.group_id" v-model="editingnodename" class="" placeholder="Type new name"
                        @keydown.esc="resetEditNode" @keydown.enter.prevent="saveEditNode" />
                    </span>
                    <!-- Type 2 = No folder -->
                    <span v-if="node.data.gdqtype == 2" class="item-text">
                      {{ node.title }}
                    </span>
                    <!-- Type 3 = Trash -->
                    <span v-if="node.data.gdqtype == 3" class="item-text">
                      {{ node.title }}
                    </span>
                    <!-- Type 4 = Add new folder -->
                    <!-- Type 5 - No folder -->
                  </template>
                  <template slot="sidebar" slot-scope="{ node }">
                    <span class="editing-toolbar"
                      v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id">
                      <span class="select-input">
                        <b-form-select v-if="node.data.gdqtype == 1" v-model="editingnodelanguage" :options="languages"
                          class="btn-tiny mr-2" />
                      </span>
                      <span class="select-input">
                        <b-form-select v-if="node.data.gdqtype == 1" v-model="editingnodenorm"
                          :options="norm_values_options" class="btn-tiny mr-2" />
                      </span>
                      <b-button v-if="node.data.isAdding" variant="danger" @click.prevent.stop="cancelAddNode(node)"
                        class="btn-tiny mr-2">Cancel</b-button>
                      <b-button v-if="!node.data.isAdding" variant="danger" @click.prevent.stop="resetEditNode"
                        class="btn-tiny mr-2">Cancel</b-button>
                      <b-button v-if="node.data.isAdding" variant="primary" @click.prevent.stop="saveAddNode"
                        class="btn-tiny mr-1">Save</b-button>
                      <b-button v-if="!node.data.isAdding" variant="primary" @click.prevent.stop="saveEditNode"
                        class="btn-tiny mr-1">Save</b-button>
                    </span>
                    <div class="ellipsis-button d-flex align-items-center" v-if="node.data.gdqtype != 2">
                      <b-dropdown right
                        v-if="(editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id)">
                        <template #button-content>
                          <i class="fa-solid fa-ellipsis"></i>
                        </template>
                        <b-dropdown-item @click.prevent="editNode()">Edit</b-dropdown-item>
                        <b-dropdown-item v-if="node.data.gdqtype == 0" @click.prevent.stop="addNode(node)">Create
                          sub-folder</b-dropdown-item>
                        <b-dropdown-item v-if="node.data.gdqtype == 1"
                          @click.prevent="removeNode()">Delete</b-dropdown-item>
                        <b-dropdown-item v-if="node.data.gdqtype == 0"
                          @click.prevent="removeNode()">Delete</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </template>
                </sl-vue-tree>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SurveyProgressBar from '..//SurveyProgressBar.vue'
import Breadcrumb from '../Breadcrumb.vue'
import Navbar from '../Navbar.vue'

export default {
  components: {
    SurveyProgressBar,
    Navbar,
    Breadcrumb
  },
  props: {
    surveytype: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      allowmultiselect: false,
      addingfolder: false,
      newfoldername: '',
      muteclass: 'text-muted',
      search: '',
      editingnode: null,
      editingnodename: '',
      editingnodelanguage: null,
      editingnodenorm: null,
      addingnodeto: null,
      addingnodename: '',
      screen_id: 1,
      total: 0,
      retrieved: 0,
      screentexts: [],
      nodes: [],
      items: [],
      loading: true,
      visible: this.$store.state.mypage_folders_open,
      languages: [],
      parent_node: {
        data: {
          gdqtype: 0,
          folder_id: 0,
          group_id: 0,
          parent_id: 0
        },
        isExpanded: false,
        path: [0]
      }
    }
  },
  computed: {
    norm_values_options: {
      get () {
        var items = this.$store.state.normvalues_countries
        var options = []
        options.push({ value: 0, text: 'Please select norm values' })
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].country_id,
            text: items[i].country_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    }
  },
  created () {
    this.groups_get()
    this.screentexts_get()
    this.languages_get()
  },
  methods: {
    handleSearch () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.groups_get()
      }, 1000)
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setfoldersopen', this.visible)
    },
    nullfunction: function () {
      return true
    },
    nullfalse: function () {
      return false
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    resetall () {
      this.addingnodeto = null
      this.editingnode = null
    },
    addNode (node, isLeaf = false) {
      var folderTree = this.$refs.folderTree
      this.addingnodeto = node
      var newNode = {
        title: 'New folder',
        isLeaf: isLeaf,
        data: {
          gdqtype: 0,
          folder_id: Date.now(),
          group_id: Date.now(),
          parent_id: node.data.folder_id,
          isAdding: true
        },
        isSelectable: false,
        isDraggable: false,
        isSelected: true
      }

      if (!node.children) {
        this.$set(node, 'children', [])
      }

      this.$set(node.children, node.children.length, newNode)

      this.$nextTick(() => {
        folderTree.updateNode(node.path, {
          isExpanded: true,
          children: node.children,
          isSelected: false
        })

        this.editingnode = newNode
        this.addingnodeto = node
        this.editingnodename = newNode.title
      })

      folderTree.traverse((node, nodeModel, path) => {
        if (node.data.isAdding == true) {
          this.cancelAddNode(node)
        }
      })
    },
    cancelAddNode (node) {
      let folderTree = this.$refs.folderTree
      this.$nextTick(() => {
        folderTree.remove([node.path])
      })
      this.resetAddNode()
    },
    resetAddNode () {
      this.addingnodeto = null
      this.editingnode = null
    },
    saveAddNode () {
      var folderTree = this.$refs.folderTree
      var parent_id = this.editingnode.data.parent_id
      var newfolder = {
        folder_name: this.editingnodename,
        parent_id: parent_id
      }
      this.addingnodename = ''
      this.$store.dispatch('folder_create', { folder: newfolder })
        .then(() => {
          this.groups_get()
        })
      this.resetAddNode()
    },
    editNode () {
      event.preventDefault()
      this.addingnode = null
      this.editingnode = null
      this.editingnodelanguage = null
      this.editingnodenorm = null
      var folderTree = this.$refs.folderTree
      folderTree.traverse((node, nodeModel, path) => {
        if (node.isSelected == true) {
          this.editingnode = node
          this.editingnodename = node.title
          this.editingnodelanguage = node.data.language_id
          this.editingnodenorm = node.data.normvalues_id
          if (node.data.gdqtype == 0) {
            this.$nextTick(() => this.$refs['f' + node.data.folder_id].focus())
          }
          if (node.data.gdqtype == 1) {
            this.$nextTick(() => this.$refs['g' + node.data.group_id].focus())
          }
        }
      })
    },
    saveEditNode () {
      var folderTree = this.$refs.folderTree
      var node = this.editingnode
      if (node.data.gdqtype == 0) {
        var folder = {
          id: node.data.folder_id,
          folder_name: this.editingnodename
        }
        this.$store.dispatch('folder_save', { folder: folder })
          .then(() => {
            this.editingnode = null
            this.editingnodename = ''
            this.groups_get()
              .then(() => {
                folderTree.select(node.path)
                folderTree.updateNode(node.path, { isExpanded: true })
                return false
              })
          })
      }
      if (node.data.gdqtype == 1) {
        var group = {
          id: node.data.group_id,
          group_name: this.editingnodename,
          group_language_id: this.editingnodelanguage,
          group_normvalues_id: this.editingnodenorm
        }
        this.$store.dispatch('group_save', { group: group })
          .then((resp) => {
            this.editingnode = null
            this.editingnodename = ''
            this.groups_get()
              .then(() => {
                this.$store.dispatch('mygdqpage_setreload', { reload: 1 })
                  .then(() => {
                    folderTree.select(node.path)
                    return false
                  })
              })
          })
      }
    },
    resetEditNode () {
      this.editingnode = null
      this.editingnodename = ''
    },
    removeNode () {
      var thisnode = null
      var folderTree = this.$refs.folderTree
      folderTree.traverse((node, nodeModel, path) => {
        if (node.isSelected == true) {
          thisnode = node
        }
      })
      var group = {
        id: thisnode.data.group_id,
        group_folder_id: -1,
        group_deleted: 1
      }
      var folder = {
        id: thisnode.data.folder_id,
        parent_id: -1,
        folder_deleted: 1
      }
      var body = {
        group: group,
        folder: folder,
        type: thisnode.data.gdqtype
      }

      let will_delete = 0

      if (confirm('Are you sure you want to delete this group?')) {
        will_delete = 1
      } else {
        will_delete = 0
      }

      var id = 0

      if (thisnode.data.gdqtype == 0) { id = thisnode.data.folder_id }
      if (thisnode.data.gdqtype == 1) { id = thisnode.data.group_id }

      if (will_delete == 1) {
        this.$store.dispatch('treeitem_save', { id: id, body: body })
          .then(() => {
            this.groups_get()
          })
      }
    },
    toggleExpand (selectednode, event) {
      if (this.addingnodeto == null && this.editingnode == null) {
        var folderTree = this.$refs.folderTree
        // ----------------------
        // Folder, toggle expand
        // ----------------------
        if (selectednode.data.gdqtype == 0 || selectednode.data.gdqtype == 3) {
          folderTree.traverse((node, nodeModel, path) => {
            if (node.data.folder_id == selectednode.data.folder_id) {
              if (node.data.folder_id != 0) {
                var expand = !(node.isExpanded)
                folderTree.updateNode(node.path, { isExpanded: expand })
              }
            }
          })
        }
      }
      // this.addingnodeto = null
    },
    checkDrop (dragginNodes, position, cancel) {
      if (position.node.data.gdqtype == 1 || position.node.data.gdqtype == 4) {
        cancel(true)
      }
    },
    nodeDropped (draggingNodes, position, event) {
      var gdqtype = draggingNodes[0].data.gdqtype
      var group_id = draggingNodes[0].data.group_id
      var folder_id = draggingNodes[0].data.folder_id
      var to_folder_id = position.node.data.folder_id
      var group_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var folder_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var group = {
        id: group_id,
        group_folder_id: to_folder_id,
        group_deleted: group_deleted
      }
      var folder = {
        id: folder_id,
        parent_id: to_folder_id,
        folder_deleted: folder_deleted
      }
      var body = {
        group: group,
        folder: folder,
        type: gdqtype
      }
      var id = 0
      if (gdqtype == 0) { id = folder_id }
      if (gdqtype == 1) { id = group_id }

      this.$store.dispatch('treeitem_save', { id: id, body: body })
        .then(() => {
          this.groups_get()
        })
    },
    groups_get: function () {
      this.loading = true
      this.$store.dispatch('foldertree_fetch', { type: 'new', search: this.search, drag: 1 })
        .then(() => {
          this.items = this.$store.state.foldertree.data
        }).then(() => {
          if (this.search) {
            this.nodes = this.items
          } else {
            this.nodes = this.restructureItems(this.items)
          }
          this.loading = false
        })
    },
    restructureItems (items) {
      let newTopLevelObject = {
        title: 'No folder',
        data: {
          'gdqtype': 2,
          'gdqindex': 203203203,
          'folder_id': 0,
          'group_id': 0,
          'parent_id': 0
        },
        children: [],
        isDraggable: false,
        isExpanded: false,
        isLeaf: false,
        isSelectable: false
      }

      let modifiedItems = items.filter(item => {
        if ((!item.children || item.children.length === 0) && item.isLeaf) {
          newTopLevelObject.children.push(item)
          return false
        }
        return true
      })

      modifiedItems.unshift(newTopLevelObject)

      if (modifiedItems.length === 1) {
        newTopLevelObject.isExpanded = true
      }

      return modifiedItems
    },
    group_setcurrent: function (group_id) {
      this.$store.dispatch('group_setcurrent', group_id)
      this.$router.push('/group')
    },
    opengroup: function (node, event) {
    },
    languages_get () {
      this.$store.dispatch('languages_fetch')
        .then((resp) => {
          this.languages = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name
            }
          })
        })
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}
</style>
